/**
 * D3 Command Brand Logo
 * Uses the official brand image asset as source of truth.
 * All variants derived from /d3-logo-transparent.png
 */

export const Logo = ({ size = 'default', showText = true, className = '' }) => {
  const heights = {
    small: 28,
    default: 36,
    large: 48,
  };
  const h = heights[size] || 36;

  return (
    <div className={`flex items-center ${className}`} data-testid="logo">
      <img
        src="/d3-logo-transparent.png"
        alt="D3 Command"
        height={h}
        style={{ height: `${h}px`, width: 'auto' }}
        data-testid={`brand-logo-${size}`}
        draggable={false}
      />
    </div>
  );
};

export const LogoIcon = ({ className = '' }) => (
  <img
    src="/favicon.png"
    alt="D3 Command"
    className={className}
    style={{ width: '32px', height: '32px' }}
    draggable={false}
  />
);
